import React from "react";

import { makeStyles, Typography } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

import kbcIcon from "../../../assets/images/kbc_icon_purple.svg";
import Button from "../../../components/Button";

const useStyles = makeStyles((theme: Theme) => ({
  svg: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    margin: theme.spacing(0, 2),
  },
  item: {
    display: "flex",
    background: "#fff",
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: theme.spacing(2, 3),
    },
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  margin: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  left: {
    display: "flex",
    alignItems: "center",
  },
}));

type RequestItemProps = {
  hospitalId: number;
  hospitalName: string;
  handleOpenRequest: (hospitalId: number, hospitalName: string) => void;
};

export default function RequestItem({
  hospitalId,
  hospitalName,
  handleOpenRequest,
}: RequestItemProps) {
  const classes = useStyles();

  return (
    <div className={classes.item}>
      <div className={classes.left}>
        <img className={classes.svg} src={kbcIcon} alt="" />
        <Typography variant="h5" color="secondary" className={classes.title}>
          {hospitalName}
        </Typography>
      </div>
      <div style={{ flexGrow: 1 }} />
      <Button
        className={classes.margin}
        onClick={() => {
          handleOpenRequest(hospitalId, hospitalName);
        }}
      >
        Prikaži zahtjev
      </Button>
    </div>
  );
}
